import styled from 'styled-components';

export const AddCommentForm = styled.form`
  display: flex;
  align-items: center;
  margin: 8px 16px 0;
  justify-content: space-between;
`;

export const InputWrapper = styled.div`
  margin-right: 8px;
  flex: 1;
`;
